import { FluidIconVMConfig } from "components/attachments/fluidIcon/fluidIcon";
import { inject, injectable } from "inversify";
import { wccModules } from "../../../../enums/wccModules";
import WCCAttachmentLayoutVM from "../base/base";
import { WCCAttachmentLayoutVMConfig } from "../base/base.interfaces";
import './box.html';
import './box.scss';

export interface WCCAttachmentBoxLayoutVMConfig extends WCCAttachmentLayoutVMConfig { }

@injectable()
export default class WCCAttachmentBoxLayoutVM extends WCCAttachmentLayoutVM {
    iconConfig: FluidIconVMConfig

    constructor(
        @inject(wccModules.componentConfig) config: WCCAttachmentBoxLayoutVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        super(config, info);

        this.iconConfig = {
            icon: this.icon,
            grow: true,
            staticContainer: true,
            scale: 1
        }

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-attachment-box-layout': true
            }
        });
    }
}